import { useOutlet } from 'react-router-dom';

type OutletTransitionProps = {
  className?: string;
};

/** Sub-rotas do tenant — sem animação para evitar glitch ao navegar entre telas da loja. */
export function OutletTransition({ className }: OutletTransitionProps) {
  const outlet = useOutlet();
  // flex-1 + min-h-0: mesma razão de shared/components/route-transition.tsx —
  // propaga altura quando o ancestral (rotas em tela cheia) tem altura definida;
  // em páginas normais da loja não muda nada, continua ajustando ao conteúdo.
  return <div className={className ?? 'flex w-full flex-1 flex-col min-h-0'}>{outlet}</div>;
}
